import { convertClustersToFlatFeaturesMap } from './convertClustersToFlatFeaturesMap';
import { convertClustersToMultipinFeaturesMap } from './convertClustersToMultipinFeaturesMap';
import { convertFrecklesToFeaturesMap } from './convertFrecklesToFeaturesMap';
import { IMapMappedResponse } from '../../../Map/types/mappedResponse';
import { IPublicWebV1MapResponse } from '../../repositories/dailyrent/entities/response/PublicWebV1MapResponse';

interface ICreateMapResponse200Options {
  /** Эксперимент мультипинов: кластер не раскрывается в «ромашку», а становится одним пином с каунтером */
  isMultipinsEnabled: boolean;
  /** Просмотренные в redux: подмешиваются в объявления мультипинов */
  viewedCianIds: Record<number, true>;
  /**
   * Первым в мультипине - объявление с ценой «от». Десктоп и планшет по клику открывают одно объявление пина -
   * первое, и его цена должна совпасть с ценой на пине. Шторка телефона показывает все объявления
   * в порядке ранжирования бэка (требования DAILY-343).
   */
  isMinPriceOfferFirst: boolean;
}

// Развилка данных эксперимента мультипинов: дальше по цепочке (сетка, слои, клик, превью)
// фичи обеих веток обрабатываются одинаково. Отметка просмотра по клику разводится в openOfferPreview.
export const createMapResponse200 =
  ({ isMultipinsEnabled, viewedCianIds, isMinPriceOfferFirst }: ICreateMapResponse200Options) =>
  (response: IPublicWebV1MapResponse): IMapMappedResponse => ({
    ...response,
    clusters: isMultipinsEnabled
      ? convertClustersToMultipinFeaturesMap(response.clusters, viewedCianIds, isMinPriceOfferFirst)
      : convertClustersToFlatFeaturesMap(response.clusters),
    freckles: convertFrecklesToFeaturesMap(response.freckles),
  });
